module.exports = __webpack_public_path__ + "img/IT0000643855945.7f05333b.png";